module.exports = __webpack_public_path__ + "img/kolibri-logo-white.7d2725b0.svg";